import React from 'react';
import {
  Control,
  FieldPath,
  FieldValues,
  useController,
} from 'react-hook-form';
import { AnchorAPI } from 'modules/AnchorAPI';
import { ImageUploader, ImageUploaderProps } from '.';

export type ControlledImageUploaderProps<T> = {
  control: Control<T>;
  name: FieldPath<T>;
} & Omit<ImageUploaderProps, 'onImageLocallyUploaded' | 'originalImage'>;

export const ControlledImageUploader = <T extends FieldValues>({
  name,
  control,
  ...html
}: ControlledImageUploaderProps<T>) => {
  const {
    field: { value, onChange },
  } = useController<T, FieldPath<T>>({ control, name });

  return (
    <ImageUploader
      {...html}
      originalImage={value}
      onImageLocallyUploaded={async (imageBlob: Blob) => {
        try {
          const { json } = await AnchorAPI.uploadImage({
            imageBlob,
          });
          onChange(json.image);
        } catch (err) {
          // current ImageUploader component can't handle errors :(
        }
      }}
    />
  );
};
